const routes = [
  // ----------------------------------- 厦门国际银行-企业微信拉新抽奖活动 ----------------------------------------
  {
    // 厦门国际银行-企业微信拉新抽奖活动-首页
    path: "/XiameBankNewGuestsHaveGifts",
    name: "XiameBankNewGuestsHaveGifts",
    component: () => import("@/views/XiameBank/newGuestsHaveGifts/index.vue"),
    meta: {
      requiresAuth: true,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-企业微信拉新抽奖活动-领取记录
    path: "/XiameBankNewGuestsHaveGiftsRecord",
    name: "XiameBankNewGuestsHaveGiftsRecord",
    component: () => import("@/views/XiameBank/newGuestsHaveGifts/record.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-企业微信拉新抽奖活动-详情
    path: "/XiameBankNewGuestsHaveGiftsDetail",
    name: "XiameBankNewGuestsHaveGiftsDetail",
    component: () => import("@/views/XiameBank/newGuestsHaveGifts/detail.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-企业微信拉新抽奖活动-规则
    path: "/XiameBankNewGuestsHaveGiftsRule",
    name: "XiameBankNewGuestsHaveGiftsRule",
    component: () => import("@/views/XiameBank/newGuestsHaveGifts/rule.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  // ----------------------------------- 厦门国际银行-生日礼 ----------------------------------------
  {
    path: "/xiamenBirthdayGift",
    name: "xiamenBirthdayGift",
    component: () => import("@/views/XiameBank/xiamenBirthdayGift/index.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    path: "/xiamenBirthdayGift/successResultPage",
    name: "xiamenBirthdayGiftSuccessResultPage",
    component: () =>
      import("@/views/XiameBank/xiamenBirthdayGift/successResultPage.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  // 厦门国际银行-生日礼-宣传页
  {
    path: "/xiamenBirthdayGiftLeafletPage",
    name: "xiamenBirthdayGiftLeafletPage",
    component: () =>
      import(
        "@/views/XiameBank/xiamenBirthdayGift/xiamenBirthdayGiftLeafletPage.vue"
      ),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  // ----------------------------------- 厦门国际银行-存款达标领取活动 ----------------------------------------
  {
    // 厦门国际银行-存款达标领取活动-首页
    path: "/XiameBankDepositStandard",
    name: "XiameBankDepositStandard",
    component: () => import("@/views/XiameBank/depositStandard/index.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-存款达标领取活动-规则
    path: "/XiameBankDepositStandardRule",
    name: "XiameBankDepositStandardRule",
    component: () => import("@/views/XiameBank/depositStandard/rule.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-存款达标领取活动-领取页面-(小程序内嵌h5，需要静默授权登录)
    path: "/XiameBankDepositStandardWxCollecting",
    name: "XiameBankDepositStandardWxCollecting",
    component: () =>
      import("@/views/XiameBank/depositStandard/wxCollecting.vue"),
    meta: {
      requiresAuth: true,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-存款达标领取活动-领取页面-(已有openId, 不需要去微信静默授权登录)
    path: "/XiameBankDepositStandardCollecting",
    name: "XiameBankDepositStandardCollecting",
    component: () =>
      import("@/views/XiameBank/depositStandard/wxCollecting.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-存款达标领取活动-领取记录
    path: "/XiameBankDepositStandardRecord",
    name: "XiameBankDepositStandardRecord",
    component: () => import("@/views/XiameBank/depositStandard/record.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-存款达标领取活动-分享页面
    path: "/XiameBankDepositStandardShare",
    name: "XiameBankDepositStandardShare",
    component: () => import("@/views/XiameBank/depositStandard/share.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-存款达标领取活动-中转页面
    path: "/XiameBankDepositStandardTransferPage",
    name: "XiameBankDepositStandardTransferPage",
    component: () =>
      import("@/views/XiameBank/depositStandard/transferPage.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },

  // ----------------------------------- 厦门国际银行理财体验官 ----------------------------------------
  {
    // 厦门国际银行理财体验官-升金有礼-首页
    path: "/XiameBankAscendGold",
    name: "XiameBankAscendGold",
    component: () => import("@/views/XiameBank/ascendGold/index.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行理财体验官-升金有礼-规则
    path: "/XiameBankAscendGoldRule",
    name: "XiameBankAscendGoldRule",
    component: () => import("@/views/XiameBank/ascendGold/rule.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行理财体验官-升金有礼-抽奖记录
    path: "/XiameBankAscendGoldRecord",
    name: "XiameBankAscendGoldRecord",
    component: () => import("@/views/XiameBank/ascendGold/record.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行理财体验官-升金有礼-领取优惠券
    path: "/XiameBankAscendGoldWxCollecting",
    name: "XiameBankAscendGoldWxCollecting",
    component: () => import("@/views/XiameBank/ascendGold/wxCollecting.vue"),
    meta: {
      requiresAuth: true,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行理财体验官-升金有礼-分享页面
    path: "/XiameBankAscendGoldShare",
    name: "XiameBankAscendGoldShare",
    component: () => import("@/views/XiameBank/ascendGold/share.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行理财体验官-升金有礼-中间页制作
    path: "/XiameBankAscendGoldTransferPage",
    name: "XiameBankAscendGoldTransferPage",
    component: () => import("@/views/XiameBank/ascendGold/transferPage.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行理财体验官-升金有礼-展示页面
    path: "/XiameBankAscendGoldDemo",
    name: "XiameBankAscendGoldDemo",
    component: () => import("@/views/XiameBank/ascendGold/demo.vue"),
    meta: {
      requiresAuth: true,
      title: "厦门国际银行",
    },
  },
  //  ------------------------------------ 中转页面 ---------------------------------------
  {
    // 2025.4.17厦门国际银行结构性存款中转页
    path: "/XiameBankStructuredDeposits1",
    name: "XiameBankStructuredDeposits1",
    component: () => import("@/views/XiameBank/structuredDeposits1.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 2025.4.30 1005833厦门国际存款中转页
    path: "/XiameBankStructuredDeposits2",
    name: "XiameBankStructuredDeposits2",
    component: () => import("@/views/XiameBank/structuredDeposits2.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  // ----------------------------------- 厦门国际银行-新客礼项目T1006430 ----------------------------------------
  {
    // 厦门国际银行-新客礼项目T1006430
    path: "/xibNewCustomerGift",
    name: "xibNewCustomerGift",
    component: () => import("@/views/XiameBank/xibNewCustomerGift"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行新客礼",
    },
  },
  {
    // 厦门国际银行-新客礼项目T1006430
    path: "/xibNewCustomerGiftWxDetail",
    name: "xibNewCustomerGiftWxDetail",
    component: () => import("@/views/XiameBank/xibNewCustomerGift/wxDetail"),
    meta: {
      requiresAuth: true,
      title: "厦门国际银行新客礼",
    },
  },
  {
    // 厦门国际银行-新客礼项目T1006430
    path: "/xibNewCustomerGiftJfDetail",
    name: "xibNewCustomerGiftJfDetail",
    component: () => import("@/views/XiameBank/xibNewCustomerGift/jfDetail"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行新客礼",
    },
  },
  {
    //  2025.5.15 1005857厦门国际存款中转页
    path: "/XiameBankStructuredDeposits3",
    name: "XiameBankStructuredDeposits3",
    component: () => import("@/views/XiameBank/structuredDeposits3.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  // ----------------------------------- 厦门国际银行-提升礼项目promotionGift ----------------------------------------
  {
    path: "/xiamePromotionGiftJhPage",
    name: "xiamePromotionGiftJhPage",
    component: () => import("@/views/XiameBank/promotionGift/jhPage.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    // 厦门国际银行-提升礼项目promotionGift-分享页面
    path: "/XiameBankPromotionGiftShare",
    name: "XiameBankPromotionGiftShare",
    component: () => import("@/views/XiameBank/promotionGift/share.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    path: "/xiamenBankJhLeafletPage",
    name: "xiamenBankJhLeafletPage",
    component: () =>
      import("@/views/XiameBank/promotionGift/xiamenBankJhLeafletPage.vue"),
    meta: {
      requiresAuth: false,
      title: "厦门国际银行",
    },
  },
  {
    path: "/xiamePromotionGift",
    name: "xiamePromotionGift",
    component: () => import("@/views/XiameBank/promotionGift/index.vue"),
    meta: {
      requiresAuth: false,
      title: "新年提升礼",
    },
  },
  // 领取详情界面
  {
    path: "/xiameBankPromotionGiftDetail",
    name: "xiameBankPromotionGiftDetail",
    component: () => import("@/views/XiameBank/promotionGift/detail.vue"),
    meta: {
      requiresAuth: false,
      title: "新年提升礼",
    },
  },
  // 跳转微信小程序领取立减金界面
  {
    path: "/xiameBankPromotionGiftWxDetail",
    name: "xiameBankPromotionGiftWxDetail",
    component: () => import("@/views/XiameBank/promotionGift/wxDetail.vue"),
    meta: {
      requiresAuth: true, // 需要微信登录
      title: "新年提升礼",
    },
  },
  // 领取失败界面
  {
    path: "/xiameBankPromotionGiftFailDetail",
    name: "xiameBankPromotionGiftFailDetail",
    component: () => import("@/views/XiameBank/promotionGift/failDetail.vue"),
    meta: {
      requiresAuth: false,
      title: "新年提升礼",
    },
  },
  // ----------------------------------- 厦门国际银行-重归白金礼项目xibReturnGift ----------------------------------------
  {
    path: "/xibReturnGift",
    name: "xibReturnGift",
    component: () => import("@/views/XiameBank/xibReturnGift/index.vue"),
    meta: {
      requiresAuth: false,
      title: "重归白金礼",
    },
  },
  {
    path: "/xibReturnGiftAddressForm",
    name: "xibReturnGiftAddressForm",
    component: () => import("@/views/XiameBank/xibReturnGift/addressForm.vue"),
    meta: {
      requiresAuth: false,
      title: "重归白金礼",
    },
  },
  {
    path: "/xibReturnGiftCollectRecord",
    name: "xibReturnGiftCollectRecord",
    component: () =>
      import("@/views/XiameBank/xibReturnGift/collectRecord.vue"),
    meta: {
      requiresAuth: false,
      title: "重归白金礼",
    },
  },
];

export default routes;
